__turbopack_context__.v({
  "accent": "mini-chips-module-scss-module__KpJSJq__accent",
  "ads": "mini-chips-module-scss-module__KpJSJq__ads",
  "contained": "mini-chips-module-scss-module__KpJSJq__contained",
  "default": "mini-chips-module-scss-module__KpJSJq__default",
  "end-icon": "mini-chips-module-scss-module__KpJSJq__end-icon",
  "error": "mini-chips-module-scss-module__KpJSJq__error",
  "error-fill": "mini-chips-module-scss-module__KpJSJq__error-fill",
  "inverse-success": "mini-chips-module-scss-module__KpJSJq__inverse-success",
  "inverse-warning": "mini-chips-module-scss-module__KpJSJq__inverse-warning",
  "large": "mini-chips-module-scss-module__KpJSJq__large",
  "medium": "mini-chips-module-scss-module__KpJSJq__medium",
  "mini-chips": "mini-chips-module-scss-module__KpJSJq__mini-chips",
  "outline": "mini-chips-module-scss-module__KpJSJq__outline",
  "pay": "mini-chips-module-scss-module__KpJSJq__pay",
  "primary": "mini-chips-module-scss-module__KpJSJq__primary",
  "round-accent": "mini-chips-module-scss-module__KpJSJq__round-accent",
  "round-contained": "mini-chips-module-scss-module__KpJSJq__round-contained",
  "secondary": "mini-chips-module-scss-module__KpJSJq__secondary",
  "small": "mini-chips-module-scss-module__KpJSJq__small",
  "start-icon": "mini-chips-module-scss-module__KpJSJq__start-icon",
  "success": "mini-chips-module-scss-module__KpJSJq__success",
  "text": "mini-chips-module-scss-module__KpJSJq__text",
  "warning": "mini-chips-module-scss-module__KpJSJq__warning",
});
